import UrlSearchParams from '@ungap/url-search-params';
import { RequestLogTypes, RequestTypes, RedirectDataTypes } from './types';
import { AxiosManager } from './AxiosManager';
import { v4 as uuidv4 } from 'uuid';
import CryptoJS from 'crypto-js';
import CryptoJSAesJson from './aesJson';
import { ExitGameManager } from './ExitGameManager';
import { errorManager, modes, MobileDetector, appMessageController } from '@powerplay/common';
export class RequestManager {
    axiosManager;
    exitGameManager = new ExitGameManager();
    USER_AUTH_TOKEN = '';
    ID_DISCIPLINE = 0;
    MINIGAME_START_ID = '';
    MINIGAME_UUID = '';
    specialRedirect = '';
    closeIframeRedirect = false;
    appRedirect = false;
    localRedirect = false;
    envData;
    TUTORIAL_ID = undefined;
    QUEST_ID = undefined;
    tournamentId = undefined;
    tournamentType = undefined;
    isSuperMatch = false;
    multiplicatorName = '';
    callbackDisposeObjects;
    language = '';
    get disciplineID() {
        return this.ID_DISCIPLINE;
    }
    set disciplineID(disciplineID) {
        this.ID_DISCIPLINE = disciplineID;
    }
    isFirstTrainingTutorial() {
        return ['13', 'returnFromTrainingLive'].includes(this.TUTORIAL_ID ?? '');
    }
    setEnvData(data) {
        this.envData = data;
    }
    setCallbackDisposeObjects(callback) {
        this.callbackDisposeObjects = callback;
    }
    setMinigameUUID() {
        this.MINIGAME_UUID = window.localStorage.getItem('minigameUUID') ?? '';
        if (!this.MINIGAME_UUID) {
            this.MINIGAME_UUID = uuidv4();
            window.localStorage.setItem('minigameUUID', this.MINIGAME_UUID);
        }
        console.log(`UUID minihry je ${this.MINIGAME_UUID}`);
    }
    setParamsFromURL() {
        const search = new UrlSearchParams(window.location.search);
        const token = search.get('token') ?? '';
        const mode = search.get('mode') ?? 1;
        const discipline = search.get('discipline_id') ?? 1;
        const superMatch = search.get('supermatch');
        this.multiplicatorName = search.get('multiplicator_name') ?? '';
        if (!token || !mode || !discipline) {
            throw new Error(errorManager.showBox('PARAMS from URL -- error, malo by byt ?token=XXX&mode=Y&discipline_id=Z'));
        }
        this.USER_AUTH_TOKEN = token.toString();
        this.ID_DISCIPLINE = Number(discipline);
        modes.mode = Number(mode);
        this.isSuperMatch = superMatch === 'true';
        const tutorialID = search.get('tutorial_id');
        if (tutorialID && tutorialID !== '0' && tutorialID !== '') {
            this.TUTORIAL_ID = String(tutorialID);
        }
        const questID = search.get('quest_id');
        if (questID)
            this.QUEST_ID = parseInt(questID);
        const specialRedirect = search.get('redirect');
        if (specialRedirect)
            this.specialRedirect = String(specialRedirect);
        const closeIframeRedirect = search.get('in_iframe');
        if (closeIframeRedirect)
            this.closeIframeRedirect = true;
        const appRedirect = search.get('app_redirect');
        if (appRedirect)
            this.appRedirect = true;
        const localRedirect = search.get('local_redirect');
        if (localRedirect)
            this.localRedirect = true;
        const externalApp = search.get('external_app');
        if (externalApp)
            modes.isExternalApp = true;
        const language = search.get('lang');
        if (language)
            this.language = language;
        const tournamentId = search.get('tournament_id');
        if (tournamentId)
            this.tournamentId = tournamentId;
        const tournamentType = search.get('tournament_type');
        if (tournamentType)
            this.tournamentType = tournamentType;
        console.log('PARAMS from URL..\n', `token = ${this.USER_AUTH_TOKEN}\n`, `mode = ${modes.mode}\n`, `discipline = ${this.ID_DISCIPLINE}\n`);
    }
    create() {
        this.setParamsFromURL();
        this.setMinigameUUID();
        this.axiosManager = new AxiosManager(this.USER_AUTH_TOKEN, this.envData);
        this.exitGameManager.init(this.TUTORIAL_ID ?? '');
    }
    getAxiosManager() {
        if (!this.axiosManager) {
            this.axiosManager = new AxiosManager(this.USER_AUTH_TOKEN, this.envData);
        }
        return this.axiosManager;
    }
    sendHintCrossRequest = (callback) => {
        this.getAxiosManager().sendRequest('get', RequestTypes.hintCross, {
            mode: modes.mode,
            discipline_id: this.ID_DISCIPLINE,
            tournament_id: this.tournamentId,
            tournament_type: this.tournamentType
        }, (dataCallback) => {
            console.log('HINT CROSS REQUEST DONE', dataCallback);
            callback();
        }, (dataCallback) => {
            throw new Error(errorManager.showBox(`HINT CROSS REQUEST ERROR: ${dataCallback}`));
        });
    };
    sendTranslationsRequest = (callback) => {
        const dataToSend = modes.isExternalApp ?
            { lang: this.language } :
            ['minigame'];
        this.getAxiosManager().sendRequest('post', RequestTypes.translations, dataToSend, (dataCallback) => {
            const serverData = dataCallback;
            console.log('TRANSLATIONS REQUEST DONE', serverData);
            callback(serverData.minigame);
        }, (dataCallback) => {
            throw new Error(errorManager.showBox(`TRANSLATIONS REQUEST ERROR: ${dataCallback}`));
        });
    };
    sendSettingsRequest = (callback) => {
        this.getAxiosManager().sendRequest('get', RequestTypes.settings, {
            mode: modes.mode,
            discipline_id: this.ID_DISCIPLINE,
            tournament_id: this.tournamentId,
            tournament_type: this.tournamentType
        }, (dataCallback) => {
            console.log('SETTINGS REQUEST DONE', dataCallback);
            const serverData = dataCallback;
            callback(serverData);
        }, (dataCallback) => {
            throw new Error(errorManager.showBox(`SETTINGS REQUEST ERROR: ${dataCallback}`));
        });
    };
    sendInitRequest = (callback, retries) => {
        const dataRequest = {
            mode: modes.mode,
            discipline_id: this.ID_DISCIPLINE,
            tournament_id: this.tournamentId,
            tournament_type: this.tournamentType,
            supermatch: this.isSuperMatch
        };
        if (modes.isAppWSM2021()) {
            dataRequest.user_games_uuid = this.MINIGAME_UUID;
        }
        if (this.QUEST_ID !== undefined) {
            dataRequest.quest_id = this.QUEST_ID;
        }
        console.log('data send to init', dataRequest);
        const postfixAction = this.envData.isLocal && retries > 0 ?
            'RetryTraining' :
            '';
        this.getAxiosManager().sendRequest('post', RequestTypes.init + postfixAction, dataRequest, (dataCallback) => {
            console.log('INIT REQUEST DONE', dataCallback);
            const serverData = dataCallback;
            this.MINIGAME_START_ID = serverData.match_id;
            callback(serverData);
        }, (dataCallback) => {
            throw new Error(errorManager.showBox(`INIT REQUEST ERROR: ${dataCallback}`));
        }, true);
    };
    sendUpdateParamsRequest = (callback) => {
        this.getAxiosManager().sendRequest('post', RequestTypes.updateParams, {
            mode: modes.mode,
            discipline_id: this.ID_DISCIPLINE,
            tournament_id: this.tournamentId,
            tournament_type: this.tournamentType,
            minigame_start_id: this.MINIGAME_START_ID,
            multiplicator_name: this.multiplicatorName
        }, (dataCallback) => {
            console.log('UPDATE PARAMS REQUEST DONE', dataCallback);
            callback();
        }, (dataCallback) => {
            throw new Error(errorManager.showBox(`UPDATE PARAMS REQUEST ERROR: ${dataCallback}`));
        });
    };
    sendSaveResultsRequest = (callback, data) => {
        this.getAxiosManager().sendRequest('post', RequestTypes.saveResults, {
            mode: modes.mode,
            discipline_id: this.ID_DISCIPLINE,
            tournament_id: this.tournamentId,
            tournament_type: this.tournamentType,
            minigame_start_id: this.MINIGAME_START_ID,
            multiplicator_name: this.multiplicatorName,
            data: this.encrypt(data)
        }, (dataCallback) => {
            console.log('SAVE RESULTS REQUEST DONE', dataCallback);
            callback(dataCallback);
            this.exitGameManager.activateExit(RequestTypes.saveResults);
        }, (dataCallback) => {
            throw new Error(errorManager.showBox(`SAVE RESULTS REQUEST ERROR: ${dataCallback}`));
        }, true);
    };
    sendSaveBetweenResultsRequest = (data, callback) => {
        console.log('nothing', data, callback);
    };
    sendSaveSettingsRequest = (data) => {
        this.getAxiosManager().sendRequest('put', RequestTypes.settingsPut, data, (dataCallback) => {
            console.log('SAVE SETTINGS REQUEST DONE', dataCallback);
        }, (dataCallback) => {
            console.log('SAVE SETTINGS REQUEST ERROR', dataCallback);
            throw new Error(`SAVE SETTINGS REQUEST ERROR: ${dataCallback}`);
        });
    };
    sendLogRequest = (type, data) => {
        const dataRequest = {
            mode: modes.mode,
            discipline_id: this.ID_DISCIPLINE,
            tournament_id: this.tournamentId,
            tournament_type: this.tournamentType,
            minigame_start_id: this.MINIGAME_START_ID,
            type,
            ...data
        };
        if (modes.isAppWSM2021()) {
            dataRequest.user_games_uuid = this.MINIGAME_UUID;
        }
        this.getAxiosManager().sendRequest('put', RequestTypes.log, dataRequest, (dataCallback) => {
            console.log('LOG REQUEST DONE', dataCallback);
            if (type === RequestLogTypes.end) {
                this.exitGameManager.activateExit(RequestTypes.log);
            }
        }, (dataCallback) => {
            console.log('LOG REQUEST ERROR', dataCallback);
            throw new Error(`LOG REQUEST ERROR: ${dataCallback}`);
        });
    };
    sendTutorialRequest = (callback) => {
        if (!this.TUTORIAL_ID)
            return;
        const dataRequest = {
            tutorials_actions_id: Number(this.TUTORIAL_ID),
            action_name: this.TUTORIAL_ID
        };
        this.getAxiosManager().sendRequest('put', RequestTypes.tutorial, dataRequest, (dataCallback) => {
            console.log('TUTORIAL REQUEST DONE', dataCallback);
            if (callback)
                callback();
            this.exitGameManager.activateExit(RequestTypes.tutorial);
        }, (dataCallback) => {
            throw new Error(errorManager.showBox(`TUTORIAL REQUEST ERROR: ${dataCallback}`));
        });
    };
    redirect = (forced = false) => {
        if (forced)
            this.sendTutorialRequest();
        if (!forced && !this.exitGameManager.active)
            return;
        const data = {
            mode: modes.mode,
            [RedirectDataTypes.disciplineID]: this.ID_DISCIPLINE
        };
        if (!forced)
            data[RedirectDataTypes.reportID] = this.MINIGAME_START_ID;
        if (this.specialRedirect)
            data[RedirectDataTypes.redirect] = this.specialRedirect;
        if (this.tournamentId)
            data[RedirectDataTypes.tournamentId] = this.tournamentId;
        if (this.tournamentType)
            data[RedirectDataTypes.tournamentType] = this.tournamentType;
        this.callbackDisposeObjects();
        setTimeout(() => {
            this.redirectToLink(data);
        }, 200);
    };
    redirectToLink = (data) => {
        const closeGameObject = {
            closeGame: true
        };
        if (this.closeIframeRedirect) {
            console.log('REDIRECT close iframe with data: ', data);
            window.parent.postMessage({
                ...closeGameObject,
                ...data
            }, '*');
            return;
        }
        if (this.appRedirect) {
            appMessageController.sendMessage(JSON.stringify({
                event: 'closeMinigame',
                data: {
                    ...closeGameObject,
                    ...data
                }
            }));
            return;
        }
        const url = this.envData.redirect;
        const page = this.envData.redirectPage;
        let link = `${url}/${page}/`;
        let i = 0;
        for (const [key, value] of Object.entries(data)) {
            link += `${i === 0 ? '?' : '&'}${key}=${value}`;
            i++;
        }
        if (this.envData.isLocal) {
            console.log(`REDIRECT to link ${link}`);
            if (this.localRedirect) {
                link = '../';
            }
            else {
                return;
            }
        }
        if (MobileDetector.android) {
            document.location = link;
        }
        else {
            window.location.href = link;
        }
    };
    encrypt = (data) => {
        const initializationVector = 'b6e54ebca5d176c9ad6da94eaf4ea797';
        const salt = 'a25af1226f6925ba';
        const dataForCrpyt = data.replace(/"/g, '\\"');
        const crypt = `{"ct":"${dataForCrpyt}","iv":"${initializationVector}","s":"${salt}"}`;
        const cryptFormat = CryptoJSAesJson;
        const key = this.MINIGAME_START_ID;
        const encrypted = CryptoJS.AES.encrypt(crypt, key, { format: cryptFormat }).toString();
        console.log('decrypted', this.decrypt(encrypted));
        return encrypted;
    };
    decrypt = (crypt) => {
        const cryptEncoding = CryptoJS.enc.Utf8;
        const cryptFormat = CryptoJSAesJson;
        const key = this.MINIGAME_START_ID;
        return CryptoJS.AES.decrypt(crypt, key, { format: cryptFormat }).toString(cryptEncoding);
    };
    getImg64 = async (url, prefix) => {
        return this.getAxiosManager().getImg64(url, prefix);
    };
    reset() {
        this.exitGameManager.reset();
    }
}
//# sourceMappingURL=RequestManager.js.map